import React, { Component, useState } from "react";
import $ from "jquery";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { database } from "../helpers/firebase";
import { ToastContainer } from "react-toastify";
import { Redirect } from "react-router-dom";
import toast from "../../helpers/toast";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigDoctor";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl"; // Backup Way to Convert
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import Patnewcss from "../../public/css/doctor/doctor.css";
import DoctorHeader from "../doctor/DoctorHeader";
import DoctormainSideMenu from "./DoctormainSidemenu";
import PatientFooter from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");
export default class Doctordashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      files: [],
      doctor_id: "",
      doc_data: [],
      telemedInprogressAppointmentList: "",
      telemedAppointmentUpcomingList: "",
      response: [],
      modalvisible: "modal collapse-hide",
      user_type: "",
    };

    this.viewAllTelemedicineAppointment = this.viewAllTelemedicineAppointment.bind(
      this
    );
    this.joinAppointment = this.joinAppointment.bind(this);
    this.close = this.close.bind(this);
    this.modalShow = this.modalShow.bind(this);
  }
  viewAllTelemedicineAppointment = () => {
    window.location.href = "./Doctortelemedicineappointments";
  };

  viewDoctorSlots = () => {
    window.location.href = "./Doctorviewslots";
  };
  viewAppointments = () => {
    window.location.href = "./Doctortelemedicineappointments";
  };
  viewProfile = () => {
    window.location.href = "./Doctorprofile";
  };
  viewRevenue = () => {
    window.location.href = "./DoctorConsultationHistory";
  };
  componentDidMount = () => {
    var retrievedObject = ls.get("DocuserObj");
    let userData = retrievedObject;
    this.state.doctor_id = userData.doctor_id;
    this.state.user_type = userData.user_type;
    this.getTelemedicineOverview();
    this.getTelemedicineInprogessAppointmentList();
    this.getTelemedicineUpcomingAppointmentList();
    this.getTelemedicinePastAppointmentList();
    this.getTelemedicineFutureAppointmentList();
    const interval = setInterval(() => {
      this.getTelemedicineOverview();
      this.getTelemedicineInprogessAppointmentList();
      this.getTelemedicineUpcomingAppointmentList();
      this.getTelemedicinePastAppointmentList();
      this.getTelemedicineFutureAppointmentList();
    }, 10000);
  };
  getTelemedicineOverview = () => {
    var retrievedObject = ls.get("DocuserObj");

    if (!retrievedObject) {
      window.location.href = "/doctor/login";
    }
    let userData = retrievedObject;
    this.setState({
      doctor_id: userData.doctor_id,
    });
    var post_data = {
      doctorId: userData.doctor_id,
      consultationDate: moment().format("YYYY-MM-DD"),
    };
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/PatientAppointment/getTodayAppointmentCount",
      post_data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          this.setState({
            doctor_id: userData.doctor_id,
            todayDate: moment().format("YYYY-MM-DD"),
            todayTelemedicinePatientCount:
              response.data.data.telemedicine[0].todayPatientCount,
            todayTelemedicineUpcomingCount:
              response.data.data.telemedicine[0].todayUpcomingCount,
            todayTelemedicineInprogressCount:
              response.data.data.telemedicine[0].todayInprogressCount,
            todayTelemedicineCompletedCount:
              response.data.data.telemedicine[0].todayCompletedCount,
            todayTelemedicineCancelledCount:
              response.data.data.telemedicine[0].todayCancelledCount,

            todayClinicPatientCount:
              response.data.data.clinic[0].todayPatientCount,
            todayClinicUpcomingCount:
              response.data.data.clinic[0].todayUpcomingCount,
            todayClinicInprogressCount:
              response.data.data.clinic[0].todayInprogressCount,
            todayClinicCompletedCount:
              response.data.data.clinic[0].todayCompletedCount,
            todayClinicCancelledCount:
              response.data.data.clinic[0].todayCancelledCount,
            todayTotalRevenue: response.data.data.revenue[0].todayTotalRevenue,
          });
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // To get future appointments of a doctor
  getTelemedicineFutureAppointmentList = () => {
    let telemedAppointmentFutureList = "";
    var patientImage = "";
    var today = moment(new Date());
    var todayDate = moment(today).format("YYYY-MM-DD");
    let timeZone = moment.tz.guess();
    var post_data = {
      doctorId: this.state.doctor_id,
      appointmentDate: "",
      status: 1,
      orderBy: "ASC",
      timeZone: timeZone,
    };
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/PatientAppointment/getTodayAppointmentDetails",
      post_data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          console.log("appoint data", response);
          let futureAppointmentCount = Object.keys(response.data.data).length;
          if (futureAppointmentCount > 0) {
            telemedAppointmentFutureList = response.data.data.map(
              (appointmentdetails, num) => {
                if (appointmentdetails.patient_tbl.profile_pic != null) {
                  patientImage =
                    Constant.imgurl +
                    appointmentdetails.patient_tbl.profile_pic;
                } else {
                  if (
                    appointmentdetails.patient_tbl.gender.toLowerCase() ==
                    "male"
                  ) {
                    patientImage =
                      "../images/patient/img/Profile/Male_patient.svg";
                  } else {
                    patientImage =
                      "../images/patient/img/Profile/Female_patient.svg";
                  }
                }
                let patientAge = "";
                if (appointmentdetails.patient_tbl.dob != null) {
                  let dob = appointmentdetails.patient_tbl.dob.split("T");
                  let age = dob[0];
                  let ageYears = moment().diff(age, "years");
                  let ageMonths = moment().diff(age, "months");
                  let ageDays = moment().diff(age, "days");
                  if (ageYears > 0) {
                    if (ageYears == 1) {
                      patientAge = ageYears + " Year";
                    } else {
                      patientAge = ageYears + " Years";
                    }
                  } else if (ageMonths > 0) {
                    if (ageMonths == 1) {
                      patientAge = ageMonths + " Month";
                    } else {
                      patientAge = ageMonths + " Months";
                    }
                  } else if (ageDays > 0) {
                    patientAge = ageDays + " Days";
                  }
                }
                return (
                  <tr>
                    <td>{appointmentdetails.patient_tbl.name}</td>
                    <td>{appointmentdetails.patient_tbl.gender}</td>
                    <td>{patientAge}</td>
                    <td>
                      {" "}
                      {moment(appointmentdetails.appointment_datetime).format(
                        "DD/MM/YYYY hh:mm a"
                      )}
                    </td>
                    <td>
                      {/* <img
                        class="presc_img"
                        src="../../images/doctor-img/MedicalDetails.svg"
                      /> */}
                    </td>
                    <td>
                      <button type="button" class="join_btn">
                        Join
                      </button>
                    </td>
                  </tr>
                );
              }
            );
          } else {
            telemedAppointmentFutureList = "";
          }
          this.setState({
            telemedFutureAppointmentList: telemedAppointmentFutureList,
          });
          this.forceUpdate();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  getTelemedicineInprogessAppointmentList = () => {
    let telemedAppointmentInprogressList = "";
    var patientImage = "";
    var today = moment(new Date());
    var todayDate = moment(today).format("YYYY-MM-DD");
    let timeZone = moment.tz.guess();
    var post_data = {
      doctorId: this.state.doctor_id,
      appointmentDate: todayDate,
      status: 2,
      orderBy: "ASC",
      timeZone: timeZone,
    };
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/PatientAppointment/getTodayAppointmentDetails",
      post_data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          let inprogressAppointmentCount = Object.keys(response.data.data)
            .length;
          if (inprogressAppointmentCount > 0) {
            telemedAppointmentInprogressList = response.data.data.map(
              (appointmentdetails, num) => {
                if (appointmentdetails.patient_tbl.profile_pic != null) {
                  patientImage =
                    Constant.imgurl +
                    appointmentdetails.patient_tbl.profile_pic;
                } else {
                  if (
                    appointmentdetails.patient_tbl.gender.toLowerCase() ==
                    "male"
                  ) {
                    patientImage =
                      "../images/patient/img/Profile/Male_patient.svg";
                  } else {
                    patientImage =
                      "../images/patient/img/Profile/Female_patient.svg";
                  }
                }
                var mindiff = moment().diff(
                  appointmentdetails.appointment_datetime,
                  "minutes"
                );
                let patientAge = "";
                if (appointmentdetails.patient_tbl.dob != null) {
                  let dob = appointmentdetails.patient_tbl.dob.split("T");
                  let age = dob[0];
                  let ageYears = moment().diff(age, "years");
                  let ageMonths = moment().diff(age, "months");
                  let ageDays = moment().diff(age, "days");
                  if (ageYears > 0) {
                    if (ageYears == 1) {
                      patientAge = ageYears + " Year";
                    } else {
                      patientAge = ageYears + " Years";
                    }
                  } else if (ageMonths > 0) {
                    if (ageMonths == 1) {
                      patientAge = ageMonths + " Month";
                    } else {
                      patientAge = ageMonths + " Months";
                    }
                  } else if (ageDays > 0) {
                    patientAge = ageDays + " Days";
                  }
                }
                return (
                  <tr>
                    <td>{num + 1}</td>
                    <td>{appointmentdetails.patient_tbl.name}</td>
                    <td>{appointmentdetails.patient_tbl.gender}</td>
                    <td>{patientAge}</td>
                    <td>
                      {" "}
                      {moment(appointmentdetails.appointment_datetime).format(
                        "DD/MM/YYYY hh:mm a"
                      )}
                    </td>
                    <td>
                      {/* <img
                        class="presc_img"
                        src="../../images/doctor-img/MedicalDetails.svg"
                        id={
                          appointmentdetails.appointment_confirm_id +
                          "-" +
                          appointmentdetails.patient_id
                        }
                        onClick={this.modalShow}
                      /> */}
                    </td>
                    <td>
                      <button
                        type="button"
                        class="join_btn"
                        onClick={this.joinAppointment.bind(
                          this,
                          appointmentdetails.appointment_confirm_id +
                            "-" +
                            appointmentdetails.patient_id
                        )}
                      >
                        Rejoin
                      </button>
                    </td>
                  </tr>
                );
              }
            );
          } else {
            telemedAppointmentInprogressList = "";
          }
          this.setState({
            telemedInprogressAppointmentList: telemedAppointmentInprogressList,
          });
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  getTelemedicineUpcomingAppointmentList = () => {
    let telemedAppointmentUpcomingList = "";
    var today = moment(new Date());
    var patientImage = "";
    var todayDate = moment(today).format("YYYY-MM-DD");
    let timeZone = moment.tz.guess();

    var post_data = {
      doctorId: this.state.doctor_id,
      appointmentDate: todayDate,
      status: 1,
      orderBy: "ASC",
      timeZone: timeZone,
    };
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/PatientAppointment/getTodayAppointmentDetails",
      post_data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          let upComingAppointmentCount = Object.keys(response.data.data).length;
          if (upComingAppointmentCount > 0) {
            telemedAppointmentUpcomingList = response.data.data.map(
              (appointmentdetails, num) => {
                if (appointmentdetails.patient_tbl.profile_pic != null) {
                  patientImage =
                    Constant.imgurl +
                    appointmentdetails.patient_tbl.profile_pic;
                } else {
                  if (
                    appointmentdetails.patient_tbl.gender.toLowerCase() ==
                    "male"
                  ) {
                    patientImage =
                      "../images/patient/img/Profile/Male_patient.svg";
                  } else {
                    patientImage =
                      "../images/patient/img/Profile/Female_patient.svg";
                  }
                }

                let DocName =
                  appointmentdetails.patient_tbl.gender.toLowerCase() == "male"
                    ? "Mr." + appointmentdetails.patient_tbl.name
                    : "Ms." + appointmentdetails.patient_tbl.name;
                var mindiff = moment().diff(
                  appointmentdetails.appointment_datetime,
                  "minutes"
                );
                let patientAge = "";
                if (appointmentdetails.patient_tbl.dob != null) {
                  let dob = appointmentdetails.patient_tbl.dob.split("T");
                  let age = dob[0];
                  let ageYears = moment().diff(age, "years");
                  let ageMonths = moment().diff(age, "months");
                  let ageDays = moment().diff(age, "days");
                  if (ageYears > 0) {
                    if (ageYears == 1) {
                      patientAge = ageYears + " Year";
                    } else {
                      patientAge = ageYears + " Years";
                    }
                  } else if (ageMonths > 0) {
                    if (ageMonths == 1) {
                      patientAge = ageMonths + " Month";
                    } else {
                      patientAge = ageMonths + " Months";
                    }
                  } else if (ageDays > 0) {
                    patientAge = ageDays + " Days";
                  }
                }

                return (
                  <tr>
                    <td>{num + 1}</td>
                    <td>{DocName}</td>
                    <td>{appointmentdetails.patient_tbl.gender}</td>
                    <td>{patientAge}</td>
                    <td>
                      {" "}
                      {moment(appointmentdetails.appointment_datetime).format(
                        "DD/MM/YYYY hh:mm a"
                      )}
                    </td>
                    <td>
                      {/* <img
                        class="presc_img"
                        src="../../images/doctor-img/MedicalDetails.svg"
                        id={
                          appointmentdetails.appointment_confirm_id +
                          "-" +
                          appointmentdetails.patient_id
                        }
                        onClick={this.modalShow}
                      /> */}
                    </td>
                    {mindiff < 0 ? (
                      <td>
                        <button type="button" class="join_btn">
                          Appointment{" "}
                          {moment(
                            appointmentdetails.appointment_datetime
                          ).fromNow()}{" "}
                        </button>
                      </td>
                    ) : (
                      <td>
                        {appointmentdetails.module_type == "consult_chat" ? (
                          <button
                            type="button"
                            class="join_btn"
                            onClick={this.Chat.bind(
                              this,
                              appointmentdetails.patient_id,
                              appointmentdetails.patient_tbl.name,appointmentdetails.appointment_confirm_id
                            )}
                          >
                            {" "}
                            chat
                          </button>
                        ) : (
                          <button
                            type="button"
                            class="join_btn"
                            id={
                              appointmentdetails.appointment_confirm_id +
                              "-" +
                              appointmentdetails.patient_id
                            }
                            onClick={this.joinAppointment.bind(
                              this,
                              appointmentdetails.appointment_confirm_id +
                                "-" +
                                appointmentdetails.patient_id
                            )}
                          >
                            {" "}
                            Join
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                );
              }
            );
          }
          this.setState({
            telemedAppointmentUpcomingList: telemedAppointmentUpcomingList,
          });
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // get telemed past appointments
  getTelemedicinePastAppointmentList = () => {
    let telemedAppointmentPastList = "";
    var today = moment(new Date());
    var patientImage = "";
    var todayDate = moment(today).format("YYYY-MM-DD");
    let timeZone = moment.tz.guess();
    var post_data = {
      doctorId: this.state.doctor_id,
      appointmentDate: todayDate,
      status: 0,
      timeZone: timeZone,
    };
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/PatientAppointment/getTodayAppointmentDetails",
      post_data
    )
      .then((response) => {
        if (response.data.status == "200" && response.data.error == false) {
          let pastAppointmentCount = Object.keys(response.data.data).length;
          if (pastAppointmentCount > 0) {
            telemedAppointmentPastList = response.data.data.map(
              (appointmentdetails, num) => {
                if (appointmentdetails.patient_tbl.profile_pic != null) {
                  patientImage =
                    Constant.imgurl +
                    appointmentdetails.patient_tbl.profile_pic;
                } else {
                  if (
                    appointmentdetails.patient_tbl.gender.toLowerCase() ==
                    "male"
                  ) {
                    patientImage =
                      "../images/patient/img/Profile/Male_patient.svg";
                  } else {
                    patientImage =
                      "../images/patient/img/Profile/Female_patient.svg";
                  }
                }
                var mindiff = moment().diff(
                  appointmentdetails.appointment_datetime,
                  "minutes"
                );
                let patientAge = "";
                if (appointmentdetails.patient_tbl.dob != null) {
                  let dob = appointmentdetails.patient_tbl.dob.split("T");
                  let age = dob[0];
                  let ageYears = moment().diff(age, "years");
                  let ageMonths = moment().diff(age, "months");
                  let ageDays = moment().diff(age, "days");
                  if (ageYears > 0) {
                    if (ageYears == 1) {
                      patientAge = ageYears + " Year";
                    } else {
                      patientAge = ageYears + " Years";
                    }
                  } else if (ageMonths > 0) {
                    if (ageMonths == 1) {
                      patientAge = ageMonths + " Month";
                    } else {
                      patientAge = ageMonths + " Months";
                    }
                  } else if (ageDays > 0) {
                    patientAge = ageDays + " Days";
                  }
                }
                if (
                  appointmentdetails.status == 4 ||
                  appointmentdetails.status == 3
                ) {
                  return (
                    <tr>
                      <td>{num + 1}</td>
                      <td>{appointmentdetails.patient_tbl.name}</td>
                      <td>{appointmentdetails.patient_tbl.gender}</td>
                      <td>{patientAge}</td>
                      <td>
                        {" "}
                        {moment(appointmentdetails.appointment_datetime).format(
                          "DD/MM/YYYY hh:mm a"
                        )}
                      </td>
                      <td>
                        {/* <img
                          class="presc_img"
                          src="../../images/doctor-img/MedicalDetails.svg"
                          id={
                            appointmentdetails.appointment_confirm_id +
                            "-" +
                            appointmentdetails.patient_id
                          }
                          onClick={this.modalShow}
                        /> */}
                      </td>
                      <td>
                        {appointmentdetails.status == 3 ? (
                          <a
                            href={
                             // Constant.imgurl +
                              appointmentdetails.prescription_id
                            }
                            target="_blank"
                          >
                            <img
                              class="presc_img"
                              src="../../images/doctor-img/prescription.svg"
                              id={appointmentdetails.appointment_confirm_id}
                            />
                          </a>
                        ) : (
                          ""
                        )}
                        {appointmentdetails.status == 2 ? (
                          <a
                            id={
                              appointmentdetails.appointment_confirm_id +
                              "-" +
                              appointmentdetails.patient_id
                            }
                            onClick={this.joinAppointment.bind(
                              this,
                              appointmentdetails.appointment_confirm_id +
                                "-" +
                                appointmentdetails.patient_id
                            )}
                          >
                            <p class="write_pre"> Write Prescription</p>
                          </a>
                        ) : (
                          ""
                        )}
                        {appointmentdetails.status == 1 ? (
                          <a
                            id={
                              appointmentdetails.appointment_confirm_id +
                              "-" +
                              appointmentdetails.patient_id
                            }
                            onClick={this.joinAppointment.bind(
                              this,
                              appointmentdetails.appointment_confirm_id +
                                "-" +
                                appointmentdetails.patient_id
                            )}
                          >
                            <p class="write_pre"> Write Prescription</p>
                          </a>
                        ) : (
                          ""
                        )}
                        {appointmentdetails.status == 4 ? (
                          <img
                            class="presc_img"
                            src="../../images/doctor-img/Cancel.svg"
                          />
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  );
                }
              }
            );
          }
          this.setState({
            telemedAppointmentPastList: telemedAppointmentPastList,
          });
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  joinAppointment = (id) => {
    let data = id.split("-");
    let appointmentId = data[1];
    let patientId = data[2];
    ls.set("DoctorSelectedConsultation", JSON.parse(appointmentId));
    ls.set("DoctorSelectedPatientId", JSON.parse(patientId));
    window.location.href = "./Doctorvideoconsultation";
  };
  close = () => {
    this.setState({
      modal: false,
      modalvisible: "modal collapse-hide",
    });
  };
  modalShow = (e) => {
    let appointmentId = "";
    let patientId = "";
    let patientData = e.currentTarget.id;
    if (patientData != "") {
      let patientDetails = patientData.split("-");
      appointmentId = patientDetails[0];
      patientId = patientDetails[1];
    }

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/Patients/getMedicalDetails/",
      {
        appointment_id: parseInt(appointmentId),
        patient_id: parseInt(patientId),
      }
    ).then((response) => {
      let patientCurrentMedication = "";
      let patientDrugAllergies = "";
      let symptoms_tbls = "";
      let patientMedicalDocument = [];
      let imagedata = [];
      let patientAge = "";
      let chornicDiseases_list = "";
      let relatedMedication = "";
      let drugAllergies = "";
      let symptoms = "";
      let bloodPressureSystolic = "";
      let bloodPressureDiastolic = "";
      let height = "";
      let weight = "";
      let bmi = "";
      let pulse_rate = "";
      let respiratory_rate = "";
      let skip_blood_pressure = "";
      let temperature = "";
      let patientName =
        response.data.data[0].name.charAt(0).toUpperCase() +
        response.data.data[0].name.slice(1);
      let gender = response.data.data[0].gender;
      let diagnostics = "";
      let consultationPurpose = "";
      let pasthistory = "";

      if (
        Object.keys(response.data.data[0].patient_past_histories).length > 0
      ) {
        let pastLength =
          response.data.data[0].patient_past_histories[0][
            "patient_current_medication"
          ].length;
        if (pastLength > 0) {
          for (var past = 0; past < pastLength; past++) {
            patientCurrentMedication =
              patientCurrentMedication +
              "," +
              response.data.data[0].patient_past_histories[0][
                "patient_current_medication"
              ][past]["medicinename"];
          }
        }
      }
      //alert(currentMedication);
      if (
        Object.keys(response.data.data[0].patient_past_histories).length > 0
      ) {
        let drugAllergiesLength =
          response.data.data[0].patient_past_histories[0][
            "patient_drug_allergies"
          ].length;
        if (drugAllergiesLength > 0) {
          for (var past = 0; past < drugAllergiesLength; past++) {
            patientDrugAllergies =
              patientDrugAllergies +
              "," +
              response.data.data[0].patient_past_histories[0][
                "patient_drug_allergies"
              ][past]["medicinename"];
          }
        }
      }
      if (response.data.data[0].drug_allergies) {
        if (Object.keys(response.data.data[0].drug_allergies).length > 0) {
          let drugAllergiesLength = response.data.data[0].drug_allergies.length;
          if (drugAllergiesLength > 0) {
            for (var past = 0; past < drugAllergiesLength; past++) {
              patientDrugAllergies =
                patientDrugAllergies +
                "," +
                response.data.data[0].drug_allergies[past]["medicinename"];
            }
          }
        }
      }

      if (Object.keys(response.data.data[0].problem_tbls).length > 0) {
        consultationPurpose = response.data.data[0].problem_tbls[0]["problem"];
      }

      if (Object.keys(response.data.data[0].symptoms_tbls).length > 0) {
        diagnostics = response.data.data[0].symptoms_tbls[0].doctor_diagnosis;
        let symptomsLength =
          response.data.data[0].symptoms_tbls[0]["symptoms"].length;
        if (response.data.data[0].symptoms_tbls[0].add_more_symptoms != null) {
          symptoms_tbls =
            response.data.data[0].symptoms_tbls[0].add_more_symptoms;
        }
        if (symptomsLength > 0) {
          for (var past = 0; past < symptomsLength; past++) {
            symptoms_tbls =
              symptoms_tbls +
              "," +
              response.data.data[0].symptoms_tbls[0]["symptoms"][past][
                "description"
              ];
          }
        }
      }

      let documentsLength = response.data.data[0].patient_past_histories
        ? response.data.data[0].patient_past_histories.length
        : 0;
      // alert(documentsLength);
      if (documentsLength > 0) {
        for (var pastdoc = 0; pastdoc < documentsLength; pastdoc++) {
          let pastHistory = response.data.data[0].patient_past_histories[
            pastdoc
          ]["patient_medical_document"]
            ? response.data.data[0].patient_past_histories[pastdoc][
                "patient_medical_document"
              ].length
            : 0;
          for (let doc = 0; doc < pastHistory; doc++) {
            patientMedicalDocument[
              doc
            ] = response.data.data[0].patient_past_histories[pastdoc][
              "patient_medical_document"
            ][doc].replace("jpeg", "jpg");
            //  alert(patientMedicalDocument);
            imagedata[doc] =
              '<div class="med_upload_box"><img src=' +
              Constant.imgurl +
              patientMedicalDocument[doc] +
              "><p>Health record " +
              (doc + 1) +
              "</p></div>";
          }
        }
      }

      if (response.data.data[0].dob != null) {
        let dob = response.data.data[0].dob.split("T");
        let age = dob[0];
        let ageYears = moment().diff(age, "years");
        let ageMonths = moment().diff(age, "months");
        let ageDays = moment().diff(age, "days");
        if (ageYears > 0) {
          patientAge = ageYears + " Years";
        } else if (ageMonths != "") {
          patientAge = ageMonths + " Months";
        } else if (ageDays != "") {
          patientAge = ageDays + " Days";
        }
        // patientAge =
        //   moment(response.data.data[0].dob, "YYYY//MM/DD")
        //     .fromNow()
        //     .split(" ")[0] + " Years";
      }

      if (response.data.data[0].chornic_diseases_list != null) {
        chornicDiseases_list = response.data.data[0].chornic_diseases_list;
      }
      // alert(Object.keys(response.data.data[0].related_medication).length);
      if (response.data.data[0].related_medication != null) {
        if (Object.keys(response.data.data[0].related_medication).length > 0) {
          for (
            let medCount = 0;
            medCount <
            Object.keys(response.data.data[0].related_medication).length;
            medCount++
          ) {
            relatedMedication =
              relatedMedication +
              "," +
              response.data.data[0].related_medication[medCount][
                "medicinename"
              ];
          }
        }
      }

      if (Object.keys(response.data.data[0].vital_informations).length > 0) {
        bloodPressureSystolic =
          response.data.data[0].vital_informations[0].blood_pressure_systolic;
        bloodPressureDiastolic =
          response.data.data[0].vital_informations[0].blood_pressure_diastolic;

        if (response.data.data[0].vital_informations[0].height != "") {
          var realFeet =
            (response.data.data[0].vital_informations[0].height * 0.3937) / 12;
          var feet = Math.floor(realFeet);
          var inches = Math.round((realFeet - feet) * 12);
          feet = feet + "'," + inches + '"';
          //alert(realFeet.toFixed(2));
          //response.data.data[0].vital_informations[0].height=feet;
          //response.data.data[0].vital_informations[0].height=(response.data.data[0].vital_informations[0].height*0.0328).toFixed(2);
          let calheight = (
            response.data.data[0].vital_informations[0].height * 0.0328
          ).toFixed(2);
          if (calheight > 0) {
            let calData = calheight.split(".");
            let Inch = calData[1];
            let feets = calData[0];

            if (Inch > 12) {
              Inch = Inch.charAt(0);
            }

            response.data.data[0].vital_informations[0].height =
              feets + "'," + Inch + '"';
          }
        }

        height = response.data.data[0].vital_informations[0].height;
        weight = response.data.data[0].vital_informations[0].weight;
        bmi = response.data.data[0].vital_informations[0].bmi;
        pulse_rate = response.data.data[0].vital_informations[0].pulse_rate;
        respiratory_rate =
          response.data.data[0].vital_informations[0].respiratory_rate;
        skip_blood_pressure =
          response.data.data[0].vital_informations[0].blood_sugar;
        temperature = response.data.data[0].vital_informations[0].temperature;
      }

      if (
        symptoms_tbls.indexOf(",") > -1 &&
        response.data.data[0].symptoms_tbls[0].add_more_symptoms == null
      ) {
        symptoms_tbls = symptoms_tbls.substr(1);
      }

      if (patientDrugAllergies.indexOf(",") > -1) {
        patientDrugAllergies = patientDrugAllergies.substr(1);
      }

      //  if( chornicDiseases_list.indexOf(',') > -1){
      //   chornicDiseases_list=chornicDiseases_list.substr(1);
      //  }

      if (patientCurrentMedication.indexOf(",") > -1) {
        patientCurrentMedication = patientCurrentMedication.substr(1);
      }
      if (relatedMedication.indexOf(",") > -1) {
        relatedMedication = relatedMedication.substr(1);
      }
      if (
        response.data.data[0].patient_past_histories.length > 0 &&
        response.data.data[0].patient_past_histories[0].past_history != null
      ) {
        chornicDiseases_list =
          chornicDiseases_list +
          "," +
          response.data.data[0].patient_past_histories[0].past_history;
      }
      //  if( chornicDiseases_list.indexOf(',') > -1){
      //   chornicDiseases_list=chornicDiseases_list.substr(1);
      //  }
      if (chornicDiseases_list.charAt(0) == ",") {
        if (chornicDiseases_list.indexOf(",") > -1) {
          chornicDiseases_list = chornicDiseases_list.substr(1);
        }
      }

      //alert(patientAge);
      //alert(symptoms_tbls);
      this.setState({
        patientName: patientName.charAt(0).toUpperCase() + patientName.slice(1),
        consultationPurpose: consultationPurpose,
        gender: gender,
        dob: patientAge,
        profilePic: response.data.data[0].profile_pic,
        relation: response.data.data[0].master_relationship
          ? response.data.data[0].master_relationship.relation_name
          : "",
        chornicDiseases_list: chornicDiseases_list,
        relatedMedication: relatedMedication + patientCurrentMedication,
        drugAllergies: patientDrugAllergies,
        symptoms: symptoms_tbls,
        relationPatientId: response.data.data[0].relation_patient_id,
        appointmentId: appointmentId, //problem_tbls
        bloodPressureSystolic: bloodPressureSystolic,
        bloodPressureDiastolic: bloodPressureDiastolic,
        height: height,
        weight: weight,
        bmi: bmi,
        pulse_rate: pulse_rate,
        respiratory_rate: respiratory_rate,
        skip_blood_pressure: skip_blood_pressure,
        temperature: temperature,
        labTests: "",
        patientMedicalDocument: patientMedicalDocument,
        imagedata: imagedata,
        problem: response.data.data[0].problem_tbls[0].problem,
        doctorDiagnosis: diagnostics,
      });
    });

    this.setState({
      modal: true,
      modalvisible: "modal collapse-show",
    });

    this.forceUpdate();
  };

  //------------------------ Chat Application ------------------//
  Chat = (id, Name, appointment_confirmid) => {
    localStorage.removeItem("SenderUID");
    localStorage.removeItem("ChatuserObj");
    if (id) {
      var retrievedObject = ls.get("DocuserObj");
      let userData = retrievedObject;
      // console.log("-------1160----", userData)
      // return
      // const userobj = JSON.parse(userData);
      // const userdata = localStorage.getItem('DocuserObj');

      // console.log("------1160-----", userobj)
      let PatientId = id;
      userData.appointment_confirm_id = appointment_confirmid;
      localStorage.setItem("PatientSenderUID", PatientId);
      localStorage.setItem("ChatuserObj", JSON.stringify(userData));
      database
        .ref("users")
        .child(userData.doctor_id)
        .set({
          uid: userData.doctor_id,
          name: userData.name,
          token: "",
          status: "Hey i am using 'Patient'",
          about: "Hi friend catch me now",
          block: false,
          unblock: true,
        });

      database
        .ref("users")
        .child(PatientId)
        .set({
          uid: PatientId,
          name: Name,
          token: "",
          status: "Hey i am using 'Doctor'",
          about: "Hi friend catch me now",
          block: false,
          unblock: true,
        });
      //-------------------------------------------------------------------------//
      setTimeout(() => this.props.history.push("/DoctorChatUserList"), 1000);
    } else {
      toast.error("please Doctor");
    }
  };

  render() {
    return (
      <main id="main">
        <DoctorHeader onSelectLanguage={this.handleLanguage} />

        <I18nPropvider locale={this.state.Language}>
          <applist />
          <section id="doctor_dashboard">
            <div class="container-fluid">
              <div class="row">
                <DoctormainSideMenu onSelectLanguage={this.handleLanguage} />

                {/* <Animated animationIn="shake" animationOut="flipOutX" animationInDuration={1000} animationOutDuration={1000} isVisible={this.state.modal}> */}
                {/*
    <Modal show={this.state.modal}>
      <Modal.Header>
      {/* <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{this.state.patientName}<span>Medical Details</span></h4>
          <p>{this.state.gender},{this.state.dob}</p>
        </div> 
        <div>
          <b>{this.state.patientName}</b>
          </div>
          <div>{this.state.gender},{this.state.dob}</div>
          <a href onClick={this.close}>Close</a>
          </Modal.Header>
      <Modal.Body>
        <div><span>Patient Id:</span><span>{this.state.patient_id}</span></div>
        <div><span>Prescription Id:</span><span></span></div>
        <div>
          <h4>Vital Information</h4>
          <div><span>Pulse Rate:</span><span>{this.state.pulse_rate ? this.state.pulse_rate :"--"}</span></div>
          <div><span>Blood Pressure:</span><span>{this.state.blood_pressure_diastolic ? this.state.blood_pressure_diastolic+"mmHG" : "--"}-{this.state.blood_pressure_systolic ? this.state.blood_pressure_systolic+"mmHG":"--"}</span></div>
          <div><span>Temperature:</span><span>{this.state.temperature ? this.state.temperature : "--"}</span></div>
          <div><span>Respiratory Rate:</span><span>{this.state.respiratory ? this.state.respiratory :"--"}</span></div>
          <div><span>Height:</span><span>{this.state.height ? this.state.height : "--"}</span></div>
          <div><span>BMI:</span><span>{this.state.bmi ? this.state.bmi : "--"}</span></div>
          <div><span>Weight:</span><span>{this.state.weight ? this.state.weight : "--"}</span></div>
        </div>
        <div> 
          <h5>Past Medical History</h5>
          <div><span>{this.state.pastHistoryName}</span></div>
        </div>
        <div> 
          <h3>Diagnosis</h3>
          <div><span>{this.state.pulse_rate}</span></div>
        </div>
        <div> 
          <h3>Lab Tests</h3>
          <div><span>Pulse Rate</span><span>{this.state.pulse_rate}</span></div>
        </div>
      </Modal.Body>
      
    </Modal>    */}

                <div
                  id="upcominggModal"
                  class={this.state.modalvisible}
                  role="dialog"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          onClick={this.close}
                        >
                          &times;
                        </button>
                        <h4 class="modal-title">
                          {this.state.patientName}
                          <span>Medical Details</span>
                        </h4>
                        <p>
                          {this.state.gender},{this.state.dob}
                        </p>
                      </div>

                      <div class="modal-body">
                        {/* <p class="sch_box">16 june 2020 , 02:30 PM</p> */}
                        <div class="med_details">
                          <p>
                            Patient UHID:{" "}
                            <span>{this.state.relationPatientId}</span>
                          </p>
                          {/* <p>Prescription ID :{this.state.appointmentId}</p> */}
                        </div>
                        <div class="med_details">
                          <h2>Puropose of Visit</h2>

                          <p>{this.state.consultationPurpose}</p>
                        </div>
                        <div class="med_details">
                          <h2>Vital Information</h2>
                          <p>
                            Pulse rate:{" "}
                            <span>
                              {this.state.pulse_rate
                                ? this.state.pulse_rate
                                : "--"}{" "}
                              bpm
                            </span>
                          </p>
                          <p>
                            Blood Pressure :{" "}
                            {this.state.bloodPressureSystolic
                              ? this.state.bloodPressureSystolic
                              : "--"}{" "}
                            /
                            {this.state.bloodPressureDiastolic
                              ? this.state.bloodPressureDiastolic
                              : "--"}{" "}
                            mmHg
                          </p>
                          <p>
                            Blood Sugar :{" "}
                            <span>
                              {this.state.skip_blood_pressure
                                ? this.state.skip_blood_pressure + " mg/dL"
                                : "--"}
                            </span>
                          </p>
                          <p>
                            Temperature:{" "}
                            <span>
                              {this.state.temperature
                                ? this.state.temperature + " ℉"
                                : "--"}
                            </span>
                          </p>
                          <p>
                            Respiratory :{" "}
                            <span>
                              {this.state.respiratory_rate
                                ? this.state.respiratory_rate +
                                  " Breaths / minute"
                                : "--"}
                            </span>
                          </p>
                          <p>
                            Height:{" "}
                            <span>
                              {this.state.height
                                ? this.state.height + " Feet/Inches"
                                : "--"}
                            </span>
                          </p>
                          <p>
                            Weight :{" "}
                            <span>
                              {this.state.weight
                                ? this.state.weight + " Kg"
                                : "--"}
                            </span>
                          </p>
                          <p>
                            BMI :{" "}
                            <span>
                              {this.state.bmi
                                ? this.state.bmi + " Kg/m2"
                                : "--"}
                            </span>
                          </p>
                        </div>
                        <div class="med_details">
                          <h2>Past Medical History</h2>
                          <p>
                            Chronic Diseases:
                            {this.state.chornicDiseases_list
                              ? this.state.chornicDiseases_list
                              : "--"}
                          </p>
                          <p>
                            Related medicines:
                            {this.state.relatedMedication
                              ? this.state.relatedMedication
                              : "--"}
                          </p>
                        </div>
                        <div class="med_details">
                          <h2>Symptoms</h2>
                          <p>
                            {this.state.symptoms ? this.state.symptoms : "--"}
                          </p>
                        </div>
                        {/* <div class="med_details">
                          <h2>Diagnosis</h2>
                          <p>
                            {this.state.doctorDiagnosis
                              ? this.state.doctorDiagnosis
                              : "--"}
                          </p>
                        </div> */}
                        {/* <div class="med_details">
                          <h2>Lab Test</h2>
                          <p>
                            {this.state.labTests ? this.state.labTests : "--"}
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* </Animated> */}
                <div class="col-lg-10 col-md-9 overview_left">
                  <div class="overview_section">
                    <div class="telemed_overview">
                      <div className="row">
                        <div class="col-md-12">
                          <h2 className="dash_head">Consultations Overview</h2>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="today_pat">
                            <div className="row">
                              <div className="col-md-12">
                                <div class="info-box">
                                  <div class="dash_icon dash_blue">
                                    <img src="../images/doctor-img/Homepage/Patients.svg" />
                                  </div>
                                  {/* <img src="../images/patient/img/dash-consult.svg" /> */}
                                  <div class="dash_content">
                                    <h3>Todays patient</h3>
                                    <p>
                                      {this.state.todayTelemedicinePatientCount
                                        ? this.state
                                            .todayTelemedicinePatientCount
                                        : "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="today_pat">
                            <div className="row">
                              <div className="col-md-12">
                                <div class="info-box">
                                  <div class="dash_icon dash_green">
                                    <img src="../images/doctor-img/Homepage/Ongoings.svg" />
                                  </div>
                                  {/* <img src="../images/patient/img/dash-consult.svg" /> */}

                                  <div class="dash_content">
                                    <h3>Ongoing Consultation</h3>
                                    <p>
                                      {this.state
                                        .todayTelemedicineInprogressCount
                                        ? this.state
                                            .todayTelemedicineInprogressCount
                                        : "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="today_pat">
                            <div className="row">
                              <div className="col-md-12">
                                <div class="info-box">
                                  <div class="dash_icon dash_yellow">
                                    <img src="../images/doctor-img/Homepage/Complete.svg" />
                                  </div>

                                  <div class="dash_content">
                                    <h3>Completed Consultation</h3>
                                    <p>
                                      {this.state
                                        .todayTelemedicineCompletedCount
                                        ? this.state
                                            .todayTelemedicineCompletedCount
                                        : "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="today_pat">
                            <div className="row">
                              <div className="col-md-12">
                                <div class="info-box">
                                  <div class="dash_icon dash_red">
                                    <img src="../images/doctor-img/Homepage/pending.svg" />
                                  </div>
                                  {/* <img src="../images/patient/img/dash-consult.svg" /> */}

                                  <div class="dash_content">
                                    <h3>Upcoming Consultation</h3>
                                    <p>
                                      {this.state.todayTelemedicineUpcomingCount
                                        ? this.state
                                            .todayTelemedicineUpcomingCount
                                        : "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="today_pat">
                            <div className="row">
                              <div className="col-md-12">
                                <div class="info-box">
                                  <div class="dash_icon dash_lightblue">
                                    <img src="../images/doctor-img/Homepage/revenue.svg" />
                                  </div>
                                  {/* <img src="../images/patient/img/dash-consult.svg" /> */}

                                  <div class="dash_content">
                                    <h3>My Revenues</h3>
                                    <p>
                                      ₹{" "}
                                      {this.state.todayTotalRevenue
                                        ? this.state.todayTotalRevenue
                                        : "0"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="telemed_revenue_overview">
                            <div className="row">
                        <div className="col-lg-12">
                        <h2 className="dash_head"></h2>
                        </div>
                            </div>
                          
                           <div className="row">

                      <div class="col-lg-3 col-md-12">
                          
                          <div class="revenue_overview">
                            <div class="container">
                              <div class="row">
                                <div class="col-lg-12 col-md-12 no_padding text-mid">
                                  <div class="revenue_telemed">
                                    <h3></h3>
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                           </div> */}
                  </div>
                  <div class="doctor_content_section">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="telemed_row">
                          <h1>Appointments</h1>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        {this.state.telemedInprogressAppointmentList ? (
                          <div className="progress_app">
                            <div className="progress_head">
                              <div className="progress_title">
                                <h4>Ongoing Consultation</h4>
                              </div>
                              <div className="progress_btn">
                                {/* <button
                                class="viewbutton"
                                onClick={this.viewAllTelemedicineAppointment}
                              >
                                View All
                              </button> */}
                              </div>
                            </div>

                            <div class="table-responsive progress_table">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>S.no</th>
                                    <th>Name</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th colspan="3">Date | Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state
                                    .telemedInprogressAppointmentList ? (
                                    this.state.telemedInprogressAppointmentList
                                  ) : (
                                    <tr>
                                      <td>No Appointments</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="upcoming_app">
                          <div className="up_head">
                            <div className="up_title">
                              <h4>Upcoming Appointments</h4>
                            </div>
                            <div className="up_btn">
                              {/* <button
                                class="viewbutton"
                                onClick={this.viewAllTelemedicineAppointment}
                              >
                                View All
                              </button> */}
                            </div>
                          </div>
                          <div class="table-responsive upcoming_table">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Name</th>
                                  <th>Gender</th>
                                  <th>Age</th>
                                  <th colspan="3">Date | Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.telemedAppointmentUpcomingList ? (
                                  this.state.telemedAppointmentUpcomingList
                                ) : (
                                  <tr>
                                    <td>No Appointments</td>{" "}
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="past_app">
                          <div className="past_head">
                            <div className="past_title">
                              <h4>Completed Consultation</h4>
                            </div>
                            <div className="past_btn">
                              <button
                                class="viewbutton"
                                onClick={this.viewAllTelemedicineAppointment}
                              >
                                View All
                              </button>
                            </div>
                          </div>
                          <div class="table-responsive past_table">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Name</th>
                                  <th>Gender</th>
                                  <th>Age</th>
                                  <th colspan="3">Date | Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.telemedAppointmentPastList ? (
                                  this.state.telemedAppointmentPastList
                                ) : (
                                  <tr>
                                    <td>No Appointments</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div class="row">
                      <div class="col-lg-6 col-md-12">
                        <div class="telemed_head">
                          <h2 data-toggle="modal" data-target="#telemedModal"></h2>
                          <h2>
                            In Progress Appointments{" "}
                            <span onClick={this.viewAllTelemedicineAppointment}>
                              View all
                            </span>
                          </h2>
                        </div>

                        <div class="telemed_box">
                          {this.state.telemedInprogressAppointmentList ? (
                            this.state.telemedInprogressAppointmentList
                          ) : (
                            <div class="no_appoint">No Appointments </div>
                          )}
                          <div class="up_box">
                            <div class="up_head">
                              <h2
                                data-toggle="modal"
                                data-target="#upcominggModal"
                              >
                                Upcoming Appointments{" "}
                                <span
                                  onClick={this.viewAllTelemedicineAppointment}
                                >
                                  View all
                                </span>
                              </h2>
                            </div>
                            <div class="upcoming_section">
                              <h3>{moment().format(" dddd  Do MMMM, YYYY")}</h3>
                              {this.state.telemedAppointmentUpcomingList ? (
                                this.state.telemedAppointmentUpcomingList
                              ) : (
                                <div class="no_appoint">No Appointments </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div class="pending_main">
                            <div class="pending_head">
                              <h2>
                                Pending Appointments{" "}
                                <span
                                  onClick={this.viewAllTelemedicineAppointment}
                                >
                                  View all
                                </span>
                              </h2>
                            </div>
                            {this.state.telemedFutureAppointmentList ? (
                              <div class="pending_box">
                                {this.state.telemedFutureAppointmentList}
                              </div>
                            ) : (
                              <div class="pending_box">
                                <div class="no_appoint">No Appointments</div>
                              </div>
                            )}
                          </div>
                      </div>
                      <div class="col-lg-6 col-md-12">
                        <div class="clinic_head">
                          <h2>
                            Past Appointments{" "}
                            <span onClick={this.viewAllTelemedicineAppointment}>
                              View all
                            </span>
                          </h2>
                        </div>

                        <div class="clinic_main">
                          {this.state.telemedAppointmentPastList != "" ? (
                            this.state.telemedAppointmentPastList
                          ) : (
                            <div class="no_appoint">No Appointments</div>
                          )}
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* modal for telemedecine medical details   */}
          <div class="modal fade" id="telemedModal" role="dialog">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">
                    &times;
                  </button>
                </div>
                <div class="modal-body">
                  <div class="ask_patient_section">
                    <img src="../images/doctor-img/Medical information locked/Medical_information.svg" />
                    <h5>Medical Information Locked</h5>
                    <a href="#">
                      <p>Ask Patient's Consent</p>
                    </a>
                    <h6>
                      Seek Permission for the detailed Information of the
                      Patient
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* modal for upcoming medical details  */}
          <div id="upcominggModal" class="modal collapse-hide" role="dialog">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">
                    &times;
                  </button>
                  <h4 class="modal-title">
                    Nandini Singh<span>Medical Details</span>
                  </h4>
                  <p>F, 26years</p>
                </div>
                <div class="modal-body">
                  <p class="sch_box">16 june 2020 , 02:30 PM</p>
                  <div class="med_details">
                    <p>
                      Patient UHID: <span>NR005</span>
                    </p>
                    {/* <p>Prescription ID : 458HYN</p> */}
                  </div>
                  <div class="med_details">
                    <h2>Apollo clinic</h2>
                    <p>Madhapur, Hyderabad, Telangana</p>
                  </div>
                  <div class="med_details">
                    <h2>Vital Information</h2>
                    <p>
                      Pulse rate: <span>75BPM</span>
                    </p>
                    <p>Blood Pressure : 120mmHG- 58mmHG</p>
                    <p>
                      Temperature: <span>103F</span>
                    </p>
                    <p>
                      Respiratory : <span>22 Breaths per minute</span>
                    </p>
                    <p>
                      Height: <span>6 feet</span>
                    </p>
                    <p>
                      BMI : <span>32kg/ M2</span>
                    </p>
                    <p>
                      Weight : <span>75K</span>
                    </p>
                  </div>
                  <div class="med_details">
                    <h2>Past Medical History</h2>
                    <p>Patient suffered fever 2months back</p>
                  </div>
                  <div class="med_details">
                    <h2>Diagnosis</h2>
                    <p>Lorem Dolor sit amet fo tequa</p>
                  </div>
                  <div class="med_details">
                    <h2>Lab Test</h2>
                    <p>USG in Lower Abdomen</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </I18nPropvider>
        <PatientFooter />
      </main>
    );
  }
}
